import { useState, useEffect } from 'react';

export function useZScroll() {
    const [scrollZ, setScrollZ] = useState(0);

    useEffect(() => {
        const handleScroll = () => {
            setScrollZ(window.scrollY);
        };

        // Set initial value
        handleScroll();

        window.addEventListener("scroll", handleScroll, { passive: true });
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return scrollZ;
}
